// See https://github.com/facebook/draft-js/issues/45#issuecomment-189800287
// A less-specific version of getVisibleSelectionRect()
export default function getSelectedBlockElement() {
  const selection = window.getSelection();

  if (selection.rangeCount === 0) return null;

  let node = selection.getRangeAt(0).startContainer;

  while (node !== null) {
    if (node.getAttribute && node.getAttribute("data-block") === "true")
      return node;

    node = node.parentNode;
  }

  return null;
}
